import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import store from '@/store';
export function hasPms(code) {
  return store.state.user.pmsCodes.includes(code);
}
export function filterPms(list) {
  return list.filter(function (_ref) {
    var pms = _ref.pms;
    if (typeof pms === 'string') {
      return hasPms(pms);
    }
    if (Array.isArray(pms)) {
      return pms.find(function (item) {
        return hasPms(item);
      });
    }
    return true;
  });
}